module.exports = __webpack_public_path__ + "static/img/dlbjq_red.e7553c7.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/dlbjq_red.png
// module id = BBos
// module chunks = 2